// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30MiQ","clinicsSelect":"styles_clinicsSelect__3SDfn"};